export enum OAuthMethod {
  Google = 'google',
  Microsoft = 'microsoft',
}

export interface OAuthRedirectResponse {
  authUrl: string;
}
